<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]=" panelTitle" [description]="panelDescription" [icon]="panelIcon">

    <div class="calendar-button-container" *ngIf="!isNew && livesLicense && model.mail">
      <button *ngIf="!isNew" class="btn btn-fill btn-primary float-right calendar-button" type="button"
        (click)="onOpenCalendar()">
        <fa-icon icon="calendar-alt" size="1x" class='mr-2 calendar-icon'></fa-icon>
        Calendario

      </button>
    </div>

    <div class="row" *ngIf="model.mail || isNew ">
      <div class="col-sm-12 col-lg-6">
        <div class="row justify-content-center">

          <div class="col-10 ml-2">
            <div class="block">
              <app-form-input-app *ngIf="!isNew && conectiaLicense" [labelText]="'Nombre de usuario'"
                [isRequired]="false">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.mail" name="UserName"
                  readonly>
              </app-form-input-app>

              <app-form-input-app *ngIf="isNew || !conectiaLicense" [labelText]="'Email de usuario'"
                [isRequired]="true">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.mail" name="UserName"
                  (ngModelChange)="onEditableChange('UserName')"
                  [ngClass]="{'invalid-field ': !validUsername && model.mail}">
                <small *ngIf="!validUsername && model.mail" class="text-danger">
                  El nombre de usuario debe ser una dirección de correo electrónico válida.
                </small>
              </app-form-input-app>

              <app-form-input-app [labelText]="'Nombre'" [isRequired]="true">
                <input *ngIf="!isNew && conectiaLicense" class="form-control" autocomplete="off" type="text"
                  [(ngModel)]="model.name" name="Name" readonly>
                <input *ngIf="isNew || !conectiaLicense" class="form-control" autocomplete="off" type="text"
                  [(ngModel)]="model.name" name="Name" (ngModelChange)="onEditableChange('Name')"
                  [ngClass]="{'invalid-field ': !validName && model.name}">
                <small *ngIf="!validName && model.name" class="text-danger">
                  El nombre no es válido
                </small>
              </app-form-input-app>

              <app-form-input-app *ngIf="isNew || !conectiaLicense" [labelText]="'Primer apellido'" [isRequired]="true">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.surname1" name="Surname1"
                  (ngModelChange)="onEditableChange('Surname1')"
                  [ngClass]="{'invalid-field ': !validSurname1 && model.surname1}">
                <small *ngIf="!validSurname1 && model.surname1" class="text-danger">
                  El primer apellido no es válido
                </small>
              </app-form-input-app>

              <app-form-input-app *ngIf="isNew || !conectiaLicense" [labelText]="'Segundo apellido'"
                [isRequired]="false">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.surname2" name="Surname2"
                  (ngModelChange)="onEditableChange('Surname2')"
                  [ngClass]="{'invalid-field ': !validSurname2 && model.surname2}">
                <small *ngIf="!validSurname2 && model.surname2" class="text-danger">
                  El segundo apellido no es válido
                </small>
              </app-form-input-app>


              <app-form-input-app [labelText]="'Tipo de vía'" [isRequired]="false"
                *ngIf="model.address  && livesLicense">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.address.acronym"
                  name="address.acronym" readonly>
              </app-form-input-app>

              <app-form-input-app [labelText]="'Número'" [isRequired]="false" *ngIf="model.address && livesLicense">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.address.buildingNumber"
                  name="address.buildingNumber" readonly>
              </app-form-input-app>

              <app-form-input-app [labelText]="'Piso'" [isRequired]="false" *ngIf="model.address && livesLicense">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.address.floor"
                  name="address.floor" readonly>
              </app-form-input-app>

              <app-form-input-app [labelText]="'País'" [isRequired]="false" *ngIf="model.address && livesLicense">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.address.countryName"
                  name="address.countryID" readonly>
              </app-form-input-app>

              <app-form-input-app [labelText]="'Empresa'" [isRequired]="false"
                *ngIf="model.company?.name && !isNew && conectiaLicense">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.company.name"
                  name="companyName" readonly>
              </app-form-input-app>

            </div>
          </div>
        </div>
      </div>


      <div class="col-sm-12 col-lg-6">
        <div class="row justify-content-center">

          <div class="col-10 ml-2">
            <div class="block">
              <app-form-input-app *ngIf="livesLicense || conectiaLicense !isNew" [labelText]="'NIF'"
                [isRequired]="false">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.nif" name="NIF" readonly>
              </app-form-input-app>

              <app-form-input-app *ngIf="livesLicense || conectiaLicense && !isNew" [labelText]="'Apellidos'"
                [isRequired]="false" [margin0BottomInput]="true">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.surnames" name="Surname"
                  readonly>
              </app-form-input-app>

              <app-form-input-app [labelText]="'Nombre de la vía'" [isRequired]="false"
                *ngIf="model.address && livesLicense">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.address.streetName"
                  name="address.streetName" readonly>
              </app-form-input-app>

              <app-form-input-app [labelText]="'Escalera'" [isRequired]="false" *ngIf="model.address && livesLicense">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.address.stairWell"
                  name="address.stairwell" readonly>
              </app-form-input-app>

              <app-form-input-app [labelText]="'Puerta'" [isRequired]="false" *ngIf="model.address && livesLicense">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.address.gate"
                  name="address.gate" readonly>
              </app-form-input-app>

              <app-form-input-app [labelText]="'Código Postal'" [isRequired]="false"
                *ngIf="model.address && livesLicense">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.address.postalCode"
                  name="address.postalCode" readonly>
              </app-form-input-app>

              <div class="mt-4">
                <app-dropdown-formularios dataSize="7" placeHolder="Empresas" [required]="true"
                  [dropdownType]="'Companies'" [(ngModel)]="model.company.company1" *ngIf="isNew || !conectiaLicense"
                  (selectedValueChange)="companySelectedChanged($event)" [detailedData]="true"
                  [selectedValue]="model.company.company1">
                </app-dropdown-formularios>
              </div>

              <app-form-input-app [labelText]="'NIF del empleado'" [isRequired]="true"
                *ngIf="isNew || !conectiaLicense " [margin0Input]="true" [margin0BottomInput]="false">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.nif" name="EmployeeNif"
                  (ngModelChange)="onEditableChange('EmployeeNif')">
              </app-form-input-app>

              <div class="mt-1 d-inline-flex w-100" [ngClass]="{'mt-4': !conectiaLicense, 'mt-1': conectiaLicense}">
                <div [ngClass]="{'col-8 pl-0': !isNew, 'col-12 p-0': isNew}">
                  <app-dropdown-formularios dataSize="7" placeHolder="Acceso App"
                    [selectedValue]="model && model.enabled  + ''" (selectedValueChange)="enabledSelectedChange($event)"
                    [required]="true" [isDisabled]="model && model.mail === '---'" [dropdownType]="'YesNo'">
                  </app-dropdown-formularios>
                  <app-form-input-app *ngIf="!model.enabled && conectiaLicense" [labelText]="'Fecha de baja'"
                    [isRequired]="false">
                    <input class="form-control" autocomplete="off" type="text" [(ngModel)]="model.dropDate"
                      name="dropDate" readonly>
                  </app-form-input-app>
                </div>
                <div class="col-4 float-right pr-0" *ngIf="!isNew">
                  <button class="btn btn-fill btn-primary float-right" type="button" (click)="sendInvite()">
                    <i class="material-icons">mail</i>
                    ENVIAR INVITACIÓN
                  </button>

                </div>
              </div>



            </div>
          </div>
        </div>
      </div>

      <!-- Botonera -->
      <div class="row col-12 float-right">
        <label class="col-12"></label>
        <div class="col-12">
          <div class="form-group form-button">
            <button [disabled]="!enableSend" class="btn btn-fill btn-primary float-right"
              (click)="isNew ? onCreateUser():  onEditUser()">Guardar</button>
            <a class="btn btn-fill btn-outline-white float-right" routerLink="../">Volver</a>
          </div>
        </div>
      </div>

    </div>
  </app-generic-panel>



  <app-generic-panel [title]=" panelTitleTwo" [description]="panelDescriptionTwo" [icon]="panelIconTwo"
    *ngIf="livesLicense">

    <div *ngIf="!sectionModel.name" class="row justify-content-center ">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div class="row" *ngIf="sectionModel.name">
      <div class="col-sm-12 col-lg-6">
        <div class="row justify-content-center">
          <div class="col-10 ml-2">
            <div class="block"><app-form-input-app [labelText]="'Sección'" [isRequired]="false">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="sectionModel.name"
                  name="Section" readonly>
              </app-form-input-app>
              <app-form-input-app *ngIf="sectionModel.dualResponsibleName" [labelText]="'Validador Doble'"
                [isRequired]="false">
                <input class="form-control" autocomplete="off" type="text"
                  [(ngModel)]="sectionModel.dualResponsibleName" name="Validator" readonly>
              </app-form-input-app>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-12 col-lg-6">
        <div class="row justify-content-center">
          <div class="col-10 ml-2">
            <div class="block">
              <app-form-input-app [labelText]="'Validado por'" [isRequired]="false">
                <input class="form-control" autocomplete="off" type="text" [(ngModel)]="sectionModel.validator"
                  name="Validator" readonly>
              </app-form-input-app>
              <app-form-input-app *ngIf="sectionModel.delegateResponsibleName" [labelText]="'Validador Delegado'"
                [isRequired]="false">
                <input class="form-control" autocomplete="off" type="text"
                  [(ngModel)]="sectionModel.delegateResponsibleName" name="Validator" readonly>
              </app-form-input-app>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br><br>
  </app-generic-panel>



  <app-generic-panel [title]="panelTitleThree" [description]="panelDescriptionThree" [icon]="panelIconThree"
    *ngIf="livesLicense">
    <ng-container *ngIf="model.company && model.company.identifierNumber">
      <app-empleados-documentos-list [user]="model" [companyNif]="model.company.identifierNumber" [docsRead]="docsRead">
      </app-empleados-documentos-list>
    </ng-container>
  </app-generic-panel>


</app-generic-container>